import {createContext} from "react";

const QuestionsContext = createContext<any>({})

export default QuestionsContext